import React from 'react';
import styles from './style.module.scss';

import type { AboutUsContent } from 'data/named-content/types';

export default function AboutUsStory({ story }: { story: AboutUsContent['story'] }) {
  return (
    <div className={styles.story}>
      <div className={styles.container}>
        <h2>Our Story</h2>
        <div className={styles.content}>
          <span className={styles.divider} />
          <div className={styles.text}>
            {story.map((paragraph, index) => (
              <div key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
